import React from 'react'
import { withIcon } from '../../withIcon'

function TvIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.55806 2.55806C7.80214 2.31398 8.19786 2.31398 8.44194 2.55806L12 6.11612L15.5581 2.55806C15.8021 2.31398 16.1979 2.31398 16.4419 2.55806C16.686 2.80214 16.686 3.19786 16.4419 3.44194L13.5089 6.375H19C19.6962 6.375 20.3639 6.65156 20.8562 7.14384C21.3484 7.63613 21.625 8.30381 21.625 9V18C21.625 18.6962 21.3484 19.3639 20.8562 19.8562C20.3639 20.3484 19.6962 20.625 19 20.625H5C4.30381 20.625 3.63613 20.3484 3.14384 19.8562C2.65156 19.3639 2.375 18.6962 2.375 18V9C2.375 8.30381 2.65156 7.63613 3.14384 7.14384C3.63613 6.65156 4.30381 6.375 5 6.375H10.4911L7.55806 3.44194C7.31398 3.19786 7.31398 2.80214 7.55806 2.55806ZM5 7.625C4.63533 7.625 4.28559 7.76987 4.02773 8.02773C3.76987 8.28559 3.625 8.63533 3.625 9V18C3.625 18.3647 3.76987 18.7144 4.02773 18.9723C4.28559 19.2301 4.63533 19.375 5 19.375H19C19.3647 19.375 19.7144 19.2301 19.9723 18.9723C20.2301 18.7144 20.375 18.3647 20.375 18V9C20.375 8.63533 20.2301 8.28559 19.9723 8.02773C19.7144 7.76987 19.3647 7.625 19 7.625H5Z" fill={color}/>
    </svg>
  )
}

export default withIcon(TvIcon)
